import React from 'react';
import QuestionDetailScreen from './QuestionDetailScreen';

const QuestionViewScreen: React.FC = () => {
  // In a real app, this would come from authentication context
  // For this example, we're using Teacher role to demonstrate view-only mode
  const userRole = 'Teacher';
  
  return <QuestionDetailScreen userRole={userRole} mode="view" />;
};

export default QuestionViewScreen;
